module.exports = __webpack_public_path__ + "static/media/mcc_2018_sponsors.e8ab33e4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mcc_2018_sponsors.webp
// module id = 1501
// module chunks = 0